/**
 * Box (OrderBox) status enum and display metadata.
 *
 * i18nKey is a prefix: append '.label' for the badge,
 * '.description' for tooltips/descriptions.
 *   t(`${meta.i18nKey}.label`)        → "Active"
 *   t(`${meta.i18nKey}.description`)  → "Box is ready to accept items"
 *
 * Colors use Framework7 named colors only.
 */

export const OrderBoxStatus = {
  DRAFT:     1,
  ACTIVE:    2,
  READY:     3,
  PACKED:    4,
  SHIPPED:   5,
  DELIVERED: 6,
  CANCELLED: 7,
  CLOSED:    8,
};

export const OrderBoxStatusMeta = {
  [OrderBoxStatus.DRAFT]: {
    i18nKey: 'box.status.draft',
    color:   'gray',
    icon:    'pencil_circle',
  },
  [OrderBoxStatus.ACTIVE]: {
    i18nKey: 'box.status.active',
    color:   'blue',
    icon:    'cube_box_fill',
  },
  [OrderBoxStatus.READY]: {
    i18nKey: 'box.status.ready',
    color:   'orange',
    icon:    'paperplane',
  },
  [OrderBoxStatus.PACKED]: {
    i18nKey: 'box.status.packed',
    color:   'purple',
    icon:    'archivebox_fill',
  },
  [OrderBoxStatus.SHIPPED]: {
    i18nKey: 'box.status.shipped',
    color:   'teal',
    icon:    'airplane',
  },
  [OrderBoxStatus.DELIVERED]: {
    i18nKey: 'box.status.delivered',
    color:   'green',
    icon:    'checkmark_seal_fill',
  },
  [OrderBoxStatus.CANCELLED]: {
    i18nKey: 'box.status.cancelled',
    color:   'red',
    icon:    'xmark_circle_fill',
  },
  [OrderBoxStatus.CLOSED]: {
    i18nKey: 'box.status.closed',
    color:   'gray',
    icon:    'archivebox',
  },
};
